<div class="ads">
  <div class="d-flex w-100 flex-column">
    <div class="d-flex w-100 align-items-center justify-content-between px-4 py-3 bg-white">
      <h4 class="m-0 text-crm">{{ 'ads' | translate }}</h4>
      @if (baseService.isMobile) {
        <app-button (onChangeClick)="onCloseSidebar()" [btnType]="'icon'" matTooltip="{{ 'close' | translate }}">
          <app-icon>close</app-icon>
        </app-button>
      }
    </div>
    <mat-divider></mat-divider>
  </div>

  <div class="d-flex h-100 w-100 overflow-auto crm-scroll">
    @if (isLoader) {
      <div class="d-flex w-100 h-100 align-items-center justify-content-center">
        <app-loader size="small"></app-loader>
      </div>
    } @else {
      <div class="d-flex flex-column w-100 gap-3 px-4 py-2">
        <table class="w-100 gap-2 mx-2">
          <tr>
            <th class="p-1">№</th>
            <th class="p-1">ID оголошення</th>
            <th class="p-1">Ім'я</th>
            <th class="p-1">Разове підняття вгору</th>
            <th class="p-1">Легкий старт</th>
            <th class="p-1">Швидкий продаж</th>
            <th class="p-1">Турбо продаж</th>
          </tr>
          @for (ads of adsPrice; track ads; let i = $index) {
            <tr>
              <td class="p-1">{{ i + 1 }}</td>
              <td class="p-1">{{ ads.ad_id }}</td>
              <td class="p-1">{{ ads.ad_title }}</td>
              <td class="p-1">
                @if (!ads.vas_list[0].owned_product_expiration_timestamp) {
                  <app-checkbox
                    [checked]="ads.vas_list === ads.vas_list[0].product_id"
                    (change)="addPrice($event, ads, ADS_TYPES.VAS, ads.vas_list[0].product_id)"
                  >
                    {{ ads.vas_list[0]?.pricing.regular.formatted }}
                  </app-checkbox>
                }
                @if (ads.vas_list[0].owned_product_expiration_timestamp) {
                  {{ ads.vas_list[0]?.owned_product_expiration_timestamp }}
                }
              </td>
              <td class="p-1" [ngClass]="{ 'expiration-background': !ads.bundles[0]?.enabled }">
                <div class="d-flex flex-column">
                  <app-checkbox
                    [checked]="ads.bundle === 'bundle_basic'"
                    (change)="addPrice($event, ads, ADS_TYPES.BUNDLE, BUNDLE_TYPES.BASIC)"
                  >
                    {{ ads.bundles[0]?.pricing.regular.formatted }}
                  </app-checkbox>
                  @if (ads.bundles[0]?.owned_product_expiration_timestamp) {
                    <span class="expiration">{{ ads.bundles[0]?.owned_product_expiration_timestamp }}</span>
                  }
                </div>
              </td>
              <td class="p-1" [ngClass]="{ 'expiration-background': !ads.bundles[1]?.enabled }">
                <div class="d-flex flex-column">
                  <app-checkbox
                    [checked]="ads.bundle === 'bundle_optimum'"
                    (change)="addPrice($event, ads, ADS_TYPES.BUNDLE, BUNDLE_TYPES.OPTIMUM)"
                  >
                    {{ ads.bundles[1]?.pricing.regular.formatted }}
                  </app-checkbox>
                  @if (ads.bundles[1]?.owned_product_expiration_timestamp) {
                    <span class="expiration">{{ ads.bundles[1]?.owned_product_expiration_timestamp }}</span>
                  }
                </div>
              </td>
              <td class="p-1" [ngClass]="{ 'expiration-background': !ads.bundles[2]?.enabled }">
                <div class="d-flex flex-column">
                  <app-checkbox
                    [checked]="ads.bundle === 'bundle_premium'"
                    (change)="addPrice($event, ads, ADS_TYPES.BUNDLE, BUNDLE_TYPES.PREMIUM)"
                  >
                    {{ ads.bundles[2]?.pricing.regular.formatted }}
                  </app-checkbox>
                  @if (ads.bundles[2]?.owned_product_expiration_timestamp) {
                    <span class="expiration">{{ ads.bundles[2]?.owned_product_expiration_timestamp }}</span>
                  }
                </div>
              </td>
            </tr>
          }
        </table>
      </div>
    }
  </div>

  <div class="d-flex flex-column">
    <mat-divider></mat-divider>
    <div class="bg-white align-items-center justify-content-center d-flex w-100 gap-2 p-4">
      <h6 class="text-crm m-0">Всього: {{ totalAmount }} грн.</h6>
      <div class="flex-fill"></div>
      <div>
        @if (this.date) {
          <app-button btnType="icon" (onChangeClick)="cancelPlanner()" [matTooltip]="'cancel' | translate">
            <app-icon>event_busy</app-icon>
          </app-button>
        }
        @if (!this.date) {
          <app-button btnType="icon" (onChangeClick)="setDate()">
            <app-icon>calendar_month</app-icon>
          </app-button>
        }
      </div>
      <app-button (onChangeClick)="onCloseSidebar()">{{ 'cancel' | translate }}</app-button>
      @if (!this.date) {
        <app-button (onChangeClick)="onPay()" [disabled]="!isAnyBundleSelected() || !!this.advertsWithExpTime.length">
          {{ 'pay' | translate }}
        </app-button>
      }
      @if (this.date) {
        <app-button [customClass]="'btn-primary'" (onChangeClick)="onPay()" [disabled]="!isAnyBundleSelected()">
          {{ 'plan_packet' | translate }}
        </app-button>
      }
    </div>
  </div>
</div>

<!--<div *ngIf="baseService.isMobile" class="h-100 overflow-auto crm-scroll">-->
<!--  <div class="d-flex flex-row align-items-center justify-content-between px-4 py-3 bg-white position-sticky top-0 z-5">-->
<!--    <h4 class="m-0 text-crm">{{ ('ads' | translate) }}</h4>-->
<!--    <app-button-->
<!--      *ngIf="baseService.isMobile"-->
<!--      (onChangeClick)="onCloseSidebar()"-->
<!--      [btnType]="'icon'"-->
<!--      matTooltip="{{'close' | translate}}">-->
<!--      <app-icon>close</app-icon>-->
<!--    </app-button>-->
<!--  </div>-->
<!--  <div class="slider-container" (swipeleft)="nextSlide()" (swiperight)="prevSlide()">-->
<!--    <div class="slider" [style.transform]="getSliderTransform()">-->
<!--      <mat-card *ngFor="let card of adsList; let i = index" class="slider-card p-3 gap-3">-->
<!--        <img class="grid-item img-fluid" *ngFor="let file of card.images; let j = index;"-->
<!--             [src]="file.url" [ngClass]="{ 'd-none': j !== 0 }">-->
<!--        <mat-card-content>-->
<!--          <p>{{ card.title }}</p>-->

<!--          <div class="d-flex justify-content-between easyStart">-->
<!--            Легкий старт:-->
<!--            <app-checkbox>{{ card.advert.bundles[0]?.pricing.regular.formatted }}</app-checkbox>-->
<!--          </div>-->

<!--          <div class="d-flex justify-content-between fastSell">-->
<!--            Швидкий продаж:-->
<!--            <app-checkbox>{{ card.advert.bundles[1]?.pricing.regular.formatted }}</app-checkbox>-->
<!--          </div>-->

<!--          <div class="d-flex justify-content-between turboSell">-->
<!--            Турбо продаж:-->
<!--            <app-checkbox>{{ card.advert.bundles[2]?.pricing.regular.formatted }}</app-checkbox>-->
<!--          </div>-->
<!--        </mat-card-content>-->
<!--      </mat-card>-->
<!--    </div>-->

<!--    <div class="bullets">-->
<!--      <mat-paginator [length]="adsList.length"-->
<!--                     [pageSize]="1"-->
<!--                     [pageIndex]="currentIndex"-->
<!--                     (page)="onPageChange($event)"-->
<!--                     [showFirstLastButtons]="true"-->
<!--                     [hidePageSize]="true">-->
<!--      </mat-paginator>-->
<!--    </div>-->
<!--  </div>-->
<!--  <div class="bg-white d-flex w-100 position-sticky bottom-0 gap-2 p-4">-->
<!--    <div class="flex-fill"></div>-->
<!--    <div>-->
<!--      <app-button btnType="icon"-->
<!--                  *ngIf="this.date"-->
<!--                  (onChangeClick)="cancelPlanner()"-->
<!--                  [matTooltip]="'cancel' | translate">-->
<!--        <app-icon>event_busy</app-icon></app-button>-->
<!--      <app-button btnType="icon" *ngIf="!this.date" (onChangeClick)="setDate()"><app-icon>calendar_month</app-icon></app-button>-->
<!--    </div>-->
<!--    <app-button class="mt-2" (onChangeClick)="onCloseSidebar()">{{ 'cancel' | translate }}</app-button>-->
<!--      <app-button *ngIf="!this.date" class="mt-2" [customClass]="'btn-primary'" (onChangeClick)="onPay()">-->
<!--        {{ 'pay' | translate }}-->
<!--      </app-button>-->
<!--      <app-button *ngIf="this.date" class="mt-2" [customClass]="'btn-primary'" (onChangeClick)="onPay()">-->
<!--        {{ 'plan_packet' | translate }}-->
<!--      </app-button>-->
<!--  </div>-->
<!--</div>-->
